import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { CommonModule, Location } from '@angular/common'; // Asegúrate de importar CommonModule
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService } from '../../../core/services/alert/alert.service';
import { OrdersService } from '../../../core/services/orders/orders.service';
import { FormAddDocumentComponent } from '../../shared/form-add-document/form-add-document.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { LocalStorageService } from '../../../core/services/localStorage/local-storage.service';
import { TabsFormComponent } from './tabs-form/tabs-form.component';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';
import { CampaignFormComponent } from './campaign-form/campaign-form.component';
import { CampaignsService } from '../../../core/services/campaigns/campaigns.service';

interface Model {
  reference: string;
  name: string;
}
interface VehicleData {
  reference: string;
  model: Model[];
  engine: string;
}

@Component({
  selector: 'app-form-add-order',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    NgSelectModule,
    FormsModule,
    TabsFormComponent,
    CampaignFormComponent,
  ],
  providers: [],
  templateUrl: './form-add-order.component.html',
  styleUrl: './form-add-order.component.css',
})
export class FormAddOrderComponent implements OnChanges {
  @ViewChild(FormAddDocumentComponent)
  addDocumentComponent?: FormAddDocumentComponent;

  @ViewChild(CampaignFormComponent) campaignFormComponent?: CampaignFormComponent;

  @Output() backButtonClick = new EventEmitter<boolean>();

  @Output() addOrder = new EventEmitter<boolean>();

  @Output() formSubmit = new EventEmitter<any>();

  @Input() campaignData?: any; // Objeto opcional
  @Input() dataContainer?: any;
  @Input() document_buttons_chico = false;
  @Input() ladata: any = [];
  @Input() tab?: any;

  @Input() clientReference!: string;
  orderData: any;
  showImportantDates = false;
  account_type: any = this.authStateService.getAccountType();
  form: FormGroup = this.fb.group({});
  draft = false;
  order_reference: string = '';
  /* client_reference: string = ''; */
  client: any = '';
  guarantee_reference: string = '';
  guarantee: any = '';
  back = '';
  brand_id_modal: any;
  searchParams: any = {};
  @Input() client_reference: any;
  //viene de la data
  selectTypes: any[] = [];
  newStage: string = '';
  title = '';
  activeForm = 'campaign';
  posiblesTabs: any[] = [
    'campaign',
  ];
  clocks: any[] = [];
  docFiles: any[] = [];
  stage?: any;
  rules: any = {};
  role: any;
  helper = false;
  documentForms: string[] = ['doc-order', 'client', 'guarantee'];

  updatesTabs: any[] = [];

  helperStep = 1;
  //////////////////////////////////SI///////////////////////////////

  constructor(
    private fb: FormBuilder,
    private alertService: AlertService,
    private orderService: OrdersService,
    private campaignService: CampaignsService,
    private location: Location,
    private router: Router,
    private authStateService: AuthStateService,
  ) { }

  setVariables() {

  }


  //////////////////////////////////NO///////////////////////////////

  ngOnChanges(changes: SimpleChanges) {
    this.refrescarFormulario();
    this.role = this.authStateService.getRole();
  }


  ngAfterViewInit() {
    this.form = this.fb.group({
      stage: ['draft', Validators.required],
    });
    this.refrescarFormulario();
  }

  onSubmit() {
    const formValues = this.campaignFormComponent?.getForm();

    this.alertService.loading('swal_messages.please_wait_add_order');

    this.campaignService.addOrderToCampaign(formValues).subscribe({
      next: (data) => {
        this.alertService
          .success('swal_messages.draft_order', 'swal_messages.awesome')
          .then((result) => {
            this.emitAddOrder();
            this.orderData = data.data;
            const nuevaURL = this.location.path();
            const index = nuevaURL.indexOf('/');
            this.location.go(
              nuevaURL.substring(0, index) +
              '/orders/contracts/' +
              this.orderData.reference
            );
            this.router.navigate(['/orders/contracts/', this.orderData.reference]);
          });
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
            if (error.code == 409) {
              window.location.reload();
            }
          }
        });
      },
    });

  }

  stringToArray(original: string): string[] {
    return original
      .split(',')
      .map(item => item.trim()); // Quita espacios en caso de que los haya
  }

  setTitle() {
    this.title = this.campaignData?.client?.name
      ? this.campaignData?.client?.name +
      ' ' +
      (this.campaignData?.client?.lastname
        ? this.campaignData?.client?.lastname
        : '')
      : this.account_type === 'broker'
        ? this.campaignData?.broker_reference
        : this.account_type === 'supplier'
          ? this.campaignData?.supplier_reference
            ? this.campaignData?.supplier_reference
            : this.campaignData?.reference
          : this.campaignData?.reference;
  }

  refrescarFormulario() {
    this.setVariables();
    this.setTitle();
    this.alertService.close();
  }


  @Input() openedFromClients = false;
  @Output() closeOrderForm = new EventEmitter<void>();

  emitBackButtonClick() {
    this.closeView();
    const nuevaURL = this.location.path();
    const index = nuevaURL.indexOf('/');
    this.location.go(nuevaURL.substring(0, index));
    this.resetFieldDisabled();
    this.activeForm = 'campaign';
    this.backButtonClick.emit(true);
  }

  emitAddOrder() {
    this.addOrder.emit(true);
  }

  resetFieldDisabled() {
    for (const field in this.form.controls) {
      if (this.form.controls.hasOwnProperty(field)) {
        this.form.get(field)?.enable();
      }
    }
  }

  actualizarEstadoArchivos(nuevoArrayArchivos: any[]) {
    this.docFiles = nuevoArrayArchivos;
  }

  refrescar() {
    this.alertService.loading('swal_messages.please_wait');
    this.orderService.getDataByReference(this.campaignData.reference).subscribe({
      next: (data) => {
        this.campaignData = data.data;
        this.refrescarFormulario();
        this.alertService.close();
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
          }
        });
      },
    });
  }

  isDocumentForm(): boolean {
    return this.documentForms.includes(this.activeForm);
  }

  refrescarOrder(orderData: any) {
    this.campaignData = orderData;
    this.setVariables();
  }

  //DUPLICATE ORDER
  duplicateOrder() {
    this.alertService
      .confirmation(
        'swal_messages.duplicate_order_title',
        'swal_messages.duplicate_order_message',
        'swal_messages.confirm',
        'swal_messages.back'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.alertService.loading('swal_messages.please_wait');
          this.orderService.duplicateOrder(this.order_reference).subscribe({
            next: (data) => {
              this.alertService
                .successOk('swal_messages.duplicate_order_success')
                .then((result) => {
                  if (result.isConfirmed) {
                    this.campaignData = data.data;
                    this.updatesTabs = [];
                    this.refrescarFormulario();
                    this.emitAddOrder();
                  }
                });
            },
            error: (error) => {
              this.alertService.error('swal_messages.order_not_found');
            },
          });
        } else {
        }
      });
  }


  emitChangeBrand(brand: string) {
    this.openSelector(brand);
  }

  openSelector(brand: any) {
    this.helper = true;
    this.brand_id_modal = brand;
  }

  handleOption(option: string) {
    this.helper = false;
    this.alertService.loading();

    setTimeout(() => {
      this.alertService.close();
    }, 1000);
  }

  closeHelper() {
    this.helper = false;
  }

  //NOTAS
  activeNotesTab: string = 'public';

  onTabChanged(tab: string) {
    this.activeNotesTab = tab;
  }

  closeView() {
    this.orderService.closeView(this.order_reference).subscribe({
      next: (data) => {
      },
      error: (error) => {
        // this.alertService.error('swal_messages.order_not_found');
      }
    });
  }

  closeViewOverlay() {
    this.orderService.closeView(this.order_reference).subscribe({
      next: (data) => {
      },
      error: (error) => {
        // this.alertService.error('swal_messages.order_not_found');
      }
    });
    this.draft = false;
    this.campaignData = null;
    this.order_reference = '';
    this.client_reference = '';
    this.guarantee_reference = '';
    this.activeForm = 'general';
  }

  goContract(url: string) {
    const nuevaURL = url;
    this.router.navigate([url]);
  }

}
